const sectionList = {
  HOMEPAGE_HERO_BANNER_CAROUSEL: 'HomepageHeroBannerCarousel',
  HOMEPAGE_MARKETING_BANNER_CAROUSEL: 'HomepageMarketingBannerCarousel',
  HOMEPAGE_CATEGORY_CAROUSEL: 'HomepageCategoryCarousel',
  HOMEPAGE_FIVE_PRODUCT_CAROUSEL: 'HomepageFiveProductCarousel',
  HOMEPAGE_BRAND_CAROUSEL: 'HomepageBrandCarousel',
  HOMEPAGE_OTHER_BRAND_CAROUSEL: 'HomepageOtherBrandCarousel',
  HOMEPAGE_SINGLE_MEDIA_BANNER_CAROUSEL: 'HomepageSingleMediaBannerCarousel',
  HOMEPAGE_THREE_PRODUCT_CAROUSEL: 'HomepageThreeProductCarousel',
  SINGLE_BANNER_CAROUSEL: 'SingleBannerCarousel',
  PDP_FREQUENTLY_BOUGHT_TOGETHER_PRODUCT_CAROUSEL:
    'PdpFrequentlyBoughtTogetherProductCarousel',
  JUST_FOR_YOU_CAROUSEL: 'JustForYouCarousel',
  RECENTLY_VIEWED_CAROUSEL: 'RecentlyViewedCarousel',
  PDP_SIMILAR_PRODUCT_CAROUSEL: 'PdpSimilarProductCarousel',
  PDP_CUSTOMER_RATING: 'PdpCustomerRating',
  CAMPAIGN_HERO_BANNER_CAROUSEL: 'CampaignHeroBannerCarousel',
  CAMPAIGN_PRODUCT_CAROUSEL: 'CampaignProductCarousel',
  CAMPAIGN_POPULAR_DEALS: 'CampaignPopularDeals',
  CAMPAIGN_CATEGORY_PRODUCT_CAROUSEL: 'CampaignCategoryProductCarousel',
  ONGOING_CAMPAIGN: 'OngoingCampaign',
  CAMPAIGN_FOUR_BANNER_RECTANGLE_CAROUSEL:
    'CampaignFourBannerRectangleCarousel',
  JUST_FOR_YOU_STATIC_CAROUSEL: 'JustForYouStaticCarousel',
};

export default sectionList;
